import React from "react";
import { OrganizationDeleteDataCard } from "./OrganizationDeleteDataCard";
import { OrganizationDeleteDataUIProvider } from "./OrganizationDeleteDataUIContext";

export function OrganizationDeleteDataPage({ history }) {
  const organizationDeleteDataUIEvents = {
  };

  return (
    <OrganizationDeleteDataUIProvider
      organizationDeleteDataUIEvents={organizationDeleteDataUIEvents}
    >
      <OrganizationDeleteDataCard />
    </OrganizationDeleteDataUIProvider>
  );
}
